module.exports = __webpack_public_path__ + "img/coin4.1f08e3e.webp";